// extracted by mini-css-extract-plugin
export default {"About":"About_About__Fk05k","content":"About_content__2svn9"};